module.exports = __webpack_public_path__ + "static/media/about_black_ginssen1.113774c1.jpg";